import React from 'react';
import { Avatar } from '@fourthwall/components';
import * as S from './UserDetails.styled';
export const UserDetails = ({ name, email }) => (React.createElement(S.Content, null,
    React.createElement(S.AvatarContainer, null,
        React.createElement(Avatar, { name: name })),
    React.createElement(S.UserName, null, name),
    email && React.createElement(S.UserEmail, null, email)));
